import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import classNames from "classnames";

const Container = styled.div.attrs({ className: "dialog" })`
  position: absolute;
  top: ${props => `${props.top}px`};
  left: ${props => `${props.left}px`};
  width: 200px;
  z-index: 5;

  &.hidden {
    visibility: hidden;
    z-index: -1;
  }
`;

const getPosition = (target, ownNode) => {
  const targetEl = document.querySelector(`[data-dialog=${target}]`);

  if (!targetEl || !ownNode) {
    return [];
  }

  const targetRect = targetEl.getBoundingClientRect();
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;
  // const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  const ownNodeRect = ownNode.getBoundingClientRect();
  const ownNodeWidth = Math.abs(ownNodeRect.left - ownNodeRect.right);

  const top = targetRect.top + targetRect.height;
  const left =
    targetRect.left + ownNodeWidth > viewportWidth
      ? targetRect.right - ownNodeWidth
      : targetRect.left;

  return [top, left];
};

const Dialog = ({ children, target, show, onOutsideClick, className }) => {
  const node = useRef(null);

  useEffect(() => {
    function handleOutsideClick(event) {
      const isOutsideClick =
        node.current && !node.current.contains(event.target);

      if (isOutsideClick) onOutsideClick(event);
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [onOutsideClick, node]);

  const [top, left] = getPosition(target, node.current);

  const isHidden = !show || top === undefined;

  return (
    <Container
      className={classNames(className, { hidden: isHidden })}
      innerRef={node}
      top={top}
      left={left}
    >
      {children}
    </Container>
  );
};

Dialog.propTypes = {
  target: PropTypes.string,
  show: PropTypes.bool,
  onOutsideClick: PropTypes.func
};

Dialog.defaultProps = {
  show: true,
  onOutsideClick: () => {}
};

export default Dialog;
